import type { ExternalSourceHeader, ExternalSourceKind, GoogleSheetAccessMode, GoogleSheetOrientation } from "@/models/externalSource";
import { apiRequest } from "./functionsClient";

export interface ExternalSourceRecordsRequest {
  leagueID: string;
  sourceID?: string;
  endpointURL?: string;
  headers?: ExternalSourceHeader[];
  recordsPath?: string;
  pastedJSON?: string;
  sourceKind?: ExternalSourceKind;
  spreadsheetURL?: string;
  spreadsheetID?: string;
  spreadsheetRange?: string;
  spreadsheetTabName?: string;
  spreadsheetTabID?: number;
  sheetOrientation?: GoogleSheetOrientation;
  accessMode?: GoogleSheetAccessMode;
  googleAccessToken?: string;
}

export interface ExternalSourceRecordsResponse {
  records: Record<string, unknown>[];
  container: "array" | "keyedObject";
  suggestedRecordsPath?: string;
}

export interface GoogleSheetTabOption {
  sheetID: number;
  title: string;
  index: number;
}

export interface GoogleSheetTabsRequest {
  leagueID: string;
  spreadsheetURL?: string;
  spreadsheetID?: string;
  accessMode?: GoogleSheetAccessMode;
  googleAccessToken?: string;
}

export interface GoogleSheetTabsResponse {
  tabs: GoogleSheetTabOption[];
}

export async function fetchExternalSourceRecords(request: ExternalSourceRecordsRequest): Promise<ExternalSourceRecordsResponse> {
  return apiRequest<ExternalSourceRecordsResponse>("/external-sources/records", {
    method: "POST",
    body: request,
  });
}

export async function fetchGoogleSheetTabs(request: GoogleSheetTabsRequest): Promise<GoogleSheetTabsResponse> {
  return apiRequest<GoogleSheetTabsResponse>("/external-sources/google-sheets/tabs", {
    method: "POST",
    body: request,
  });
}
